var _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "159.977px",
    height: "100.337px",
    viewBox: "152.789 22.048 159.977 100.337",
    enableBackground: "new 152.789 22.048 159.977 100.337",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 232.235,
    cy: 72.831,
    rx: 77.71,
    ry: 47.53
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E1251B",
    d: "M263.572,25.952c9.723,2.603,18.289,6.217,25.662,10.88c7.41,4.663,13.157,10.048,17.314,16.12 c4.119,6.108,6.217,12.542,6.217,19.301s-2.061,13.192-6.217,19.302c-4.121,6.107-9.904,11.494-17.314,16.12 c-7.409,4.626-15.939,8.241-25.662,10.843c-9.723,2.604-19.988,3.868-30.759,3.868c-10.808,0-21.073-1.302-30.795-3.868 c-9.723-2.602-18.325-6.18-25.699-10.843c-7.41-4.626-13.157-10.013-17.313-16.12c-4.12-6.109-6.217-12.543-6.217-19.338 s2.061-13.229,6.217-19.337c4.121-6.108,9.904-11.458,17.313-16.084c7.41-4.626,15.976-8.241,25.699-10.843 c9.723-2.602,20.024-3.903,30.795-3.903C243.584,22.084,253.85,23.386,263.572,25.952z M204.15,31.084 c-9.072,2.349-17.024,5.602-23.928,9.759c-6.867,4.157-12.253,8.964-16.084,14.386c-3.832,5.421-5.783,11.096-5.783,17.024 s1.916,11.603,5.783,17.024c3.831,5.422,9.217,10.229,16.121,14.385c6.903,4.157,14.855,7.41,23.927,9.76 c9.036,2.35,18.579,3.506,28.627,3.506c10.012,0,19.519-1.156,28.591-3.506s17.023-5.603,23.928-9.76 c6.867-4.156,12.252-8.963,16.084-14.385c3.831-5.422,5.783-11.097,5.783-17.024s-1.916-11.603-5.783-17.024 c-3.832-5.422-9.217-10.193-16.084-14.386c-6.868-4.157-14.855-7.446-23.893-9.759c-9.035-2.35-18.578-3.506-28.626-3.506 C222.765,27.578,213.187,28.735,204.15,31.084z M192.765,69.072v-9.361h6.976v24.361h-6.976V74.53h-14.386v9.542h-6.976V59.711 h6.976v9.361H192.765z M227.175,74.566H209.03v4.048h18.145v5.494h-25.012V59.747h25.012v5.313H209.03v4.048h18.145V74.566z  M236.355,78.759h17.313v5.313h-24.036V59.711h6.687v19.048H236.355z M294.078,60.795c0.688,0.579,1.012,1.229,1.012,1.952v21.361 h-6.686V65.06h-9.94v19.048h-6.578V65.06h-9.868v19.048h-6.686V59.747h36.252C292.561,59.855,293.392,60.217,294.078,60.795z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.49f01095ae6bbb677959f5b2b91e5bc9.svg";
export { ForwardRef as ReactComponent };